'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
var _ArrowForward = require('@material-ui/icons/ArrowForward');
var _ArrowForward2 = _interopRequireDefault(_ArrowForward);
var _Button = require('./Button');
var _Button2 = _interopRequireDefault(_Button);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  container: {
    padding: '2rem 0',
    textAlign: 'center'
  }
};
var NetworkingLoginLink = function (_Component) {
  _inherits(NetworkingLoginLink, _Component);
  function NetworkingLoginLink() {
    _classCallCheck(this, NetworkingLoginLink);
    return _possibleConstructorReturn(this, (NetworkingLoginLink.__proto__ || Object.getPrototypeOf(NetworkingLoginLink)).apply(this, arguments));
  }
  _createClass(NetworkingLoginLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties;
      var _Object$keys$map$ = Object.keys(entities).map(function (k) {
          return entities[k];
        })[0],
        eventUri = _Object$keys$map$.eventUri,
        defaultLanguage = _Object$keys$map$.defaultLanguage;
      var buttonProperties = _extends({}, otherProperties, {
        href: _urls2.default.getPublicLoginUrl(eventUri, defaultLanguage),
        target: "_blank"
      });
      return _react2.default.createElement('div', {
        className: classes.container
      }, _react2.default.createElement(_Button2.default, {
        cssProperties: cssProperties,
        otherProperties: buttonProperties,
        value: "Login"
      }));
    }
  }]);
  return NetworkingLoginLink;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(NetworkingLoginLink);